import React, { useState, useEffect } from 'react';
import { getActivePromotion } from '../services/api';
import { Capacitor } from '@capacitor/core';


const PromotionPopup = () => {

  const [promotion, setPromotion] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [showIcon, setShowIcon] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPromotion();
  }, []);

  const fetchPromotion = async () => {
    try {
      const data = await getActivePromotion();
      setPromotion(data);
      
      // Check if user dismissed icon in this session
      const dismissed = false;
      setShowIcon(!dismissed && !!data);
    } catch (error) {
      console.error('Failed to fetch promotion:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDismissIcon = (e) => {
    e.stopPropagation();
    // dismissed only in memory - resets on refresh;
    setShowIcon(false);
  };

  const handleOpenPopup = () => {
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  // Don't render anything if loading or no promotion
  if (loading || !promotion || !promotion.is_active) {
    return null;
  }

  // Don't render icon if user dismissed it
  if (!showIcon) {
    return null;
  }

  return (
    <>
      {/* Ripple SVG - tròn hoàn hảo mọi thiết bị */}
      <svg style={{
        position: 'fixed',
        top: Capacitor.isNativePlatform() ? '80px' : '80px',
        right: '4px',
        width: '140px',
        height: '140px',
        pointerEvents: 'none',
        zIndex: 1000,
        overflow: 'visible'
      }}>
        <circle cx="70" cy="70" r="50" fill="rgba(239,68,68,0.4)" 
          stroke="rgba(239,68,68,0.5)" strokeWidth="3">
          <animate attributeName="r" from="50" to="80" 
            dur="2s" repeatCount="indefinite"/>
          <animate attributeName="opacity" from="0.6" to="0" 
            dur="2s" repeatCount="indefinite"/>
        </circle>
        <circle cx="70" cy="70" r="50" fill="rgba(239,68,68,0.3)"
          stroke="rgba(239,68,68,0.3)" strokeWidth="3">
          <animate attributeName="r" from="50" to="80" 
            dur="2s" begin="0.7s" repeatCount="indefinite"/>
          <animate attributeName="opacity" from="0.6" to="0" 
            dur="2s" begin="0.7s" repeatCount="indefinite"/>
        </circle>
      </svg>
     
      {/* Floating Icon - SVG để đồng bộ tọa độ với ripple */}
      <svg style={{
        position: 'fixed',
        top: Capacitor.isNativePlatform() ? '80px' : '80px',
        right: '4px',
        width: '140px',
        height: '140px',
        pointerEvents: 'all',
        zIndex: 999,
        overflow: 'visible',
        cursor: 'pointer'
      }} onClick={handleOpenPopup}>
        <foreignObject x="20" y="20" width="100" height="100">
          <div xmlns="http://www.w3.org/1999/xhtml" style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            {promotion.icon_url ? (
              <img src={promotion.icon_url} alt="Promotion"
                className="promotion-icon-img"
                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
              />
            ) : (
              <span style={{ fontSize: '40px' }}>🎁</span>
            )}
          </div>
        </foreignObject>

        {/* Dismiss X button */}
        <g onClick={(e) => { e.stopPropagation(); handleDismissIcon(e); }}>
          <circle cx="115" cy="25" r="12" fill="rgba(0,0,0,0.5)"/>
          <text x="115" y="30" textAnchor="middle" fill="white" fontSize="14" fontWeight="bold">×</text>
        </g>
      </svg>

      {/* Popup Modal */}
      {showPopup && (
        <div
          onClick={handleClosePopup}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.6)',
            backdropFilter: 'blur(4px)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px',
            animation: 'fadeIn 0.25s ease'
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: 'relative',
              width: '85vw',
              maxWidth: '380px',
              aspectRatio: '4 / 5',
              borderRadius: '20px',
              overflow: 'visible',
              boxShadow: '0 20px 60px rgba(0,0,0,0.4)',
              animation: 'scaleUp 0.25s ease'
            }}
          >
            {/* Background Image or Gradient */}
            {promotion.background_url ? (
              <img
                src={promotion.background_url}
                alt="Promotion Background"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                  position: 'absolute',
                  top: 0,
                  left: 0
                }}
              />
            ) : (
              <div
                style={{
                  width: '100%',
                  height: '100%',
                  background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                  position: 'absolute',
                  top: 0,
                  left: 0
                }}
              />
            )}

            {/* Gradient Overlay at Bottom */}
            <div
              style={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                right: 0,
                height: '45%',
                background: 'linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.75) 100%)',
                pointerEvents: 'none'
              }}
            />

            {/* Text Content */}
            <div
              style={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                right: 0,
                padding: '20px',
                color: 'white',
                zIndex: 1
              }}
            >
              {promotion.title && (
                <h2
                  style={{
                    fontSize: '20px',
                    fontWeight: 'bold',
                    marginBottom: '8px',
                    textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                  }}
                >
                  {promotion.title}
                </h2>
              )}
              {promotion.content && (
                <p
                  style={{
                    fontSize: '14px',
                    lineHeight: '1.5',
                    opacity: 0.95,
                    textShadow: '0 1px 2px rgba(0,0,0,0.3)',
                    whiteSpace: 'pre-wrap'
                  }}
                >
                  {promotion.content}
                </p>
              )}
            </div>

            {/* Close Button */}
            <button
              onClick={handleClosePopup}
              style={{
                position: 'absolute',
                top: '12px',
                right: '12px',
                width: '32px',
                height: '32px',
                borderRadius: '50%',
                background: 'rgba(0,0,0,0.4)',
                color: 'white',
                border: 'none',
                fontSize: '20px',
                fontWeight: 'bold',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 2,
                transition: 'background 0.2s'
              }}
              onMouseEnter={(e) => e.target.style.background = 'rgba(0,0,0,0.6)'}
              onMouseLeave={(e) => e.target.style.background = 'rgba(0,0,0,0.4)'}
            >
              ×
            </button>
          </div>
        </div>
      )}

      {/* CSS Animations */}
      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes scaleUp {
          from {
            transform: scale(0.9);
            opacity: 0;
          }
          to {
            transform: scale(1);
            opacity: 1;
          }
        }
      `}</style>
    </>
  );
};

export default PromotionPopup;
